import {Injectable} from "@angular/core";
import {Location} from "../../objects/management/locationManagement/location";
import {Subject} from "rxjs/Subject";
import {Subscription} from "rxjs/Subscription";

type LocationCallback = (location:Location) => void;
type IsVehicleCallback = (location:boolean) => void;

@Injectable()
export class CalculatorService {
    private handler = new Subject<Location>();
    private isVehicleHandler = new Subject<boolean>();

    broadcast(location: Location) {
        this.handler.next(location);
    }

    subscribe(callback: LocationCallback): Subscription {
        return this.handler.subscribe(callback);
    }

    broadcastIsVeh(isVehicle: boolean) {
        this.isVehicleHandler.next(isVehicle);
    }

    subscribeIsVeh(callback: IsVehicleCallback): Subscription {
        return this.isVehicleHandler.subscribe(callback);
    }
    public isMobile(): boolean {
        if (screen.width > 767)
            return false;

        return true;
    }
}


// WEBPACK FOOTER //
// ./app/services/calculator/calculatorService.ts